import './modules/core';
import campaignEditorSlots from './modules/campaign-editor-slots';
import formTestament from './modules/form-testament';
import topBar from './modules/top-bar';
import customSelect from './modules/custom-select';
import { datepicker } from './modules/datepicker';
import { importVueApp } from './modules/vue';


importVueApp('education-materials').then(app => {
  if (app) {
    // Some features need reinitializing after lazy loading the app
    customSelect('.js-custom-select');
    datepicker('.js-datepicker');
  }
});

// Forms
formTestament.initForms();

topBar.init({
  scrollThrottle: 20,
  'scroll_Limit': '20'
});

customSelect('.js-custom-select');

campaignEditorSlots.init();

datepicker('.js-datepicker');
